<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" :model="form" >
                <el-form-item label="关键词">
                    <el-input v-model="form.keywords" placeholder="关键词"></el-input>
                </el-form-item>
            </el-form>
            <div>
                <el-button type="primary" @click="add()">添加阅卷老师</el-button>
            </div>
        </div>
        <div class="panel_body">
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                    min-width="120"
                    prop="userName"
                    label="阅卷老师姓名" >
                </el-table-column>
                <el-table-column
                    min-width="120"
                    prop="phone"
                    label="登录账号" >
                </el-table-column>
                <el-table-column
                    prop="sn"
                    min-width="120"
                    label="批改题目" >
                    <template slot-scope="scope">
                        <div class="fx-col fx-center" style="color:#F56C6C" >
                            {{!scope.row.randomEnable ? scope.row.markingQuestionNames : "随机"}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="sn"
                    min-width="120"
                    label="题目数量" >
                    <template slot-scope="scope">
                        <div class="fx-col fx-center" style="color:#F56C6C">
                            {{scope.row.countEnable ? scope.row.markingCount : "不限"}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    min-width="80"
                >
                    <template slot-scope="scope">
                        <div class="fx fx-m_between fx-c_center">
                            <el-link type="primary" @click="marking(scope.row)"
                                     :underline="false" ><i class="iconfont icon-bianji font20"></i><b>批改设置</b></el-link>
                            <el-popconfirm @onConfirm="remove(scope.row)"
                                        title="确认移除该老师吗？"
                            >
                                <div slot="reference" class="fx fx-center">
                                    <el-button type="danger" icon="el-icon-minus" circle size="mini" style="padding: 2px"></el-button>
                                    <span class="remove_btn ">移除</span>
                                </div>
                            </el-popconfirm>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination
                :background="true"
                prev-text="上一页"
                next-text="下一页"
                layout="prev, pager, next"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :total="pager.dataTotal"
                @current-change="pageChange"
            >
            </el-pagination>
        </div>

        <AddDrawer v-if="showAdd" @submit="loadData"
                @close="showAdd=false" :item="editItem"></AddDrawer>
        <EditDraw v-if="showEdit" @submit="loadData"
                @close="showEdit=false" :item="editItem"></EditDraw>
    </div>
</template>

<style scoped>
    .class_title {
        display: inline-block;
        height: 40px;
        line-height: 40px;
        font-size: 16px;

    }
    .class_title i.iconfont {
        font-size: 20px;
        color: var(--primary);
    }
    .remove_btn {
        margin-left: 5px;
        cursor: pointer;
        font-size: 16px;
    }
    .remove_btn:hover {
        color: var(--danger);
    }
</style>


<script>

    import AddDrawer from './TeacherAddDrawer';
    import EditDraw from './MarkingEditDrawer';

    export default {
        components: {
            AddDrawer,
            EditDraw,
        },
        props: [
            "attr"
        ],
        data() {
            return {
                showAdd: false,
                showEdit: false,
                exam: this.attr && this.attr.exam,

                form: {
                    keywords: "",
                    examId: (this.attr && this.attr.exam) ? this.attr.exam.id : null,

                },
                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                tableData: [],
            }
        },
        watch: {
            "form": {
                handler: function (newValue) {
                    if (this.form.examId) {
                        this.pager.currentPage = 1;
                        this.loadData();
                    } else {
                        this.pager.currentPage = 1;
                        this.pager.dataTotal = 0;
                        this.tableData = [];
                    }
                },
                deep: true,
                immediate: true

            }
        },

        methods: {
            add() {
                this.editItem = {...this.exam};
                this.showAdd = true;
            },
            loadData() {
                this.$ajaxPost("/exam/getExamMarkerByExamTestId", {
                    form: this.form,
                    examId:this.form.examId,
                    pager: {...this.pager, dataTotal: 0}
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let {offset, ...pager} = data.pager;
                    this.pager = pager;
                    this.tableData = data.result;
                    this.showAdd = false;
                    this.showEdit = false;
                })
            },
            marking(marker){
                this.editItem = {...marker};
                this.showEdit = true;
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadData();
            },
            remove(user) {
                this.$ajaxGet("/examMarker/del/" + user.id, data => {
                    this.loadData();
                })
            },
        },

        created() {
            this.loadData();
        }

    }
</script>
